<script>
import { getLogoURLs } from "@/helpers/logo";

export default {
  data() {
    return {
      navbarLogoStyle: {}
    };
  },
  computed: {
    logoURL() {
      return getLogoURLs();
    }
  },
  watch: {
    '$store.getters.logos.light': {
      handler(newVal) {
        this.setNavbarStyle(newVal);
      },
      immediate: true
    }
  },
  created() {
    this.setNavbarStyle(this.$store?.getters?.logos?.light);
  },
  methods: {
    setNavbarStyle(logoUrl) {
      
      const url = logoUrl || this.logoURL.navbar;
      this.navbarLogoStyle = {
        backgroundImage: `url(${url})`,
        width: '100%',
        height: '100%',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
      };
    }
  }
};
</script>
<template>
  <router-link to="/de/dashboard">
    <div id="logo-navbar" :style="navbarLogoStyle"></div>
  </router-link>
</template>
